// extracted by mini-css-extract-plugin
export default {"GitHubAvatar":"Participant-module__GitHubAvatar--QzbCR"};